import { i18n } from '@lingui/core';

export interface NewBinderCostRecordParams extends Record<string, string | undefined> {
  projectId: string;
}

export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/new-binder-cost-record`;
export const TITLE = i18n._('New Binder Cost Record');
